import React from 'react';
import PageHero from '../components/PageHero';
import WhyChooseUs from '../components/WhyChooseUs';
import SocialProof from '../components/SocialProof';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';
import { BRAND_NAME } from '../utils/brand';

export default function WhyUs() {
  return (
    <>
      <PageHero
        eyebrow={`Why ${BRAND_NAME}`}
        title="Doctor-led care. AI-assisted support. Built for Malaysians."
        subtitle="Most weight loss services stop at a prescription. We don't. Assessment, doctor review, pharmacy fulfilment and follow-up live inside one calm experience."
      />
      <Reveal><WhyChooseUs /></Reveal>
      <Reveal><SocialProof /></Reveal>
      <CTASection />
    </>
  );
}
